export const INITIAL_DATA = 'InitialData' as const;
export const MANUAL_INPUT = 'ManualInput' as const;
export const CURRENT_BALANCE = 'CURRENT_BALANCE' as const;

export const PLAYER_FINANCIAL_HISTORY = 'PlayerFinancialHistory' as const;
export const DISCONNECTED = 'DISCONNECTED' as const;
export const PLAYER_NR_TABLE_LIMIT_REACHED = 'PLAYER_NR_TABLE_LIMIT_REACHED' as const;
export const GAME_RESULT = 'GAME_RESULT' as const;
export const LAST_BETS = 'LAST_BETS' as const;
export const LOADING = 'LOADING' as const;
export const NO_MORE_BETS = 'NO_MORE_BETS' as const;
// 2026-05 per GE colleague, INSURANCE_NO_MORE_BETS was sent only for Russian Poker (a discontinued game)
export const INSURANCE_NO_MORE_BETS = 'INSURANCE_NO_MORE_BETS' as const;
export const PLACE_YOUR_BETS = 'PLACE_YOUR_BETS' as const;
export const DYNAMIC_MULTIPLIERS = 'DynamicMultipliers' as const;
export const RECONNECTING = 'RECONNECTING' as const;
export const TABLE_CLOSED = 'TABLE_CLOSED' as const;
export const WAIT_FOR_NEXT_ROUND = 'WAIT_FOR_NEXT_ROUND' as const;
export const WAIT_FOR_NEXT_GAME = 'WAIT_FOR_NEXT_GAME' as const;
export const SKIP_PYB_TIMER = 'SkipPYBTimer' as const;
export const PLACE_BET_INTENT_POOL = 'PlaceBetIntentPool' as const;
export const REVEAL_CARDS = 'RevealCards' as const;
export const SORTED_CARDS = 'SortedCards' as const;
export const TIE = 'Tie' as const;
export const NO_MORE_BETS_DECISION = 'NoMoreBetsDecision' as const;

export const SHUFFLE = 'SHUFFLE' as const;
export const ERROR = 'Error' as const;
export const FATAL_ERROR = 'FATAL_ERROR' as const;
export const CANCEL_ROUND = 'CANCEL_ROUND' as const;
export const CLEAR_ALL_CARDS = 'CLEAR_ALL_CARDS' as const;
export const INCIDENT_OPEN = 'INCIDENT_OPEN' as const;
export const INCIDENT_CLOSED = 'INCIDENT_CLOSED' as const;
export const TABLE_CANCELLED = 'TableCancelled' as const;
export const BLOCKED_PLAYER = 'BlockedPlayer' as const;
export const OPERATOR_ERROR = 'OperatorError' as const;
export const BET_NOT_PLACED = 'BetNotPlaced' as const;

export const BET_BEHIND_RESULTS = 'BetBehindResult' as const;
export const SEAT_RESULT = 'SeatResult' as const;
export const FIRST_CARD_HANDS = 'FirstCardHands' as const;
export const CALL_BETS = 'CallBets' as const;
export const CALL_BET_DECISION = 'CallBetDecision' as const;
export const FIRST_DECISION_CALL = 'FirstDecisionCall' as const;
export const SECOND_DECISION_CALL = 'SecondDecisionCall' as const;
export const THIRD_DECISION_CALL = 'ThirdDecisionCall' as const;
export const CALL_FIRST_DECISION = 'CallFirstDecision' as const;
export const CALL_SECOND_DECISION = 'CallSecondDecision' as const;
export const CALL_THIRD_DECISION = 'CallThirdDecision' as const;
export const CALL_DECISION = 'CallDecision' as const;
export const PLAYER_TURN = 'PlayerTurn' as const;
export const INSURANCE_CALLS = 'InsuranceCalls' as const;
export const INSURANCE_DECISION = 'InsuranceDecision' as const;
export const CARD_MESSAGE = 'CardMessage' as const;
export const PLAYERS_BETS = 'PlayersBets' as const;
export const CARD = 'Card' as const;
export const WINNING_BALL = 'WinningBall' as const;
export const WINNING_BALLS = 'WinningBalls' as const;
export const CANCEL_LAST_CARD = 'CancelLastCard' as const;
export const WON_BETS = 'WonBets' as const;
export const SPLIT_CARDS = 'SplitCards' as const;
export const NO_SPIN = 'NoSpin' as const;
export const VIDEO_MODERATION_RESULT = 'VideoModerationResult' as const;

export const UPDATED_LOBBY_DATA = 'UPDATED_LOBBY_DATA' as const;
export const UPDATED_TABLE_HISTORY = 'UPDATED_TABLE_HISTORY' as const;
export const UPDATE_FREE_SEATS = 'UPDATE_FREE_SEATS' as const;
export const TABLE_OCCUPANCY = 'TABLE_OCCUPANCY' as const;
export const INITIALIZE_TABLE = 'INITIALIZE_TABLE' as const;
export const CANCEL_TABLE = 'CANCEL_TABLE' as const;
export const RESERVE_SEAT = 'ReserveSeat' as const;
export const PLAYERS_NUMBER = 'PlayersNumber' as const;

export const SERVER_DISCONNECTED_INACTIVITY = 'DisconnectedForInactivity' as const;
export const DISCONNECTED_SESSION = 'DisconnectedSession' as const;
export const RECONNECT_TO_SERVER = 'RECONNECT_TO_SERVER' as const;

export const NO_SPIN_REASON_LOW_BALL_SPIN_COUNT = 'LowBallSpinCount' as const;
export const NO_SPIN_REASON_ROTOR_AND_BALL_SAME_DIRECTION = 'RotorAndBallSameDirection' as const;
export const NO_SPIN_REASON_UNKNOWN_OBJECT_IN_THE_WHEEL = 'UnknownObjectInRim' as const;
export const NO_SPIN_REASON_BALL_NOT_IN_THE_WHEEL = 'BallNotInTheWheel' as const;
export const NO_SPIN_REASON_UNKNOWN = 'Unknown' as const;

export const TIP_PLACED = 'TipPlaced' as const;
export const TIP_NOT_PLACED = 'TipNotPlaced' as const;
export const TIP_OUT_OF_LIMITS = 'TipOutOfLimits' as const;

// Regulations
export const PLAYER_LIMITS_NOTIFICATION = 'PlayerLimitsNotification' as const;
export const REALITY_CHECK = 'RealityCheck' as const;
export const SESSION_LIMIT = 'SessionLimit' as const;
export const WAGER_LIMIT = 'WagerLimit' as const;
export const LOSS_LIMIT = 'LossLimit' as const;
export const STAKE_LIMIT = 'StakeLimit' as const; // used only for OSS
export const SESSION_DELAYED_LIMIT = 'SessionDelayedLimit' as const;
export const MAXIMUM_CREDIT_LIMIT = 'WagerSoftLimit' as const;
export const DISCONNECTED_FROM_OPERATOR = 'DisconnectedFromOperator' as const;
export const NET_POSITION = 'NET_POSITION' as const;

// Blackjack
export const TAKE_SEAT = 'TakeSeat' as const;
export const SEAT_TAKEN = 'SeatTaken' as const;
export const LEAVE_SEAT = 'LeaveSeat' as const;
/** `MessageType` of ws message sent to all blackjack variants excepting UBJ for which `GAME_RESULT` is sent */
export const GAME_RESULT_BJ = 'GameResults' as const;
export const WON_SIDE_BETS = 'WonSideBets' as const;
export const START_CALL_BETS = 'StartCallBets' as const;
export const FIRST_HAND_CARDS_MESSAGE = 'FirstHandCardsMessage' as const;

// Matka
export const SPIN_BOWL = 'SpinBowl' as const;
export const SELECT_BALLS = 'SelectBalls' as const;
/** message type received on socket when second chance starts */
export const SECOND_CHANCE = 'SecondChance' as const;

// RevolutionRoulette
export const MULTIPLIER = 'Multiplier' as const;
export const MULTIPLIER_IGNORED = 'MultiplierIgnored' as const;

// UltimateRoulette
export const BUY_MULTIPLIERS_DECISION_TIMER = 'BUY_MULTIPLIERS_DECISION_TIMER' as const;
export const BUY_MULTIPLIERS_DECISION = 'BUY_MULTIPLIERS_DECISION' as const;
export const EXTRA_MULTIPLIERS = 'EXTRA_MULTIPLIERS' as const;
export const MAIN_MULTIPLIERS = 'MAIN_MULTIPLIERS' as const;
export const SPREAD_MULTIPLIERS = 'SPREAD_MULTIPLIERS' as const;

// Bonus
export const BonusMessage = {
  BonusWheelStart: 'bonusWheelStart',
  BonusWheelCancelled: 'bonusWheelCancelled',
  BonusWheelAccepted: 'bonusWheelAccepted',
  BonusWheelFinished: 'bonusWheelFinished',
  BonusWheelOperatorError: 'bonusWheelOperatorError',
} as const;

// Ultimate Dice
export const WINNING_DICE = 'WinningDice' as const;

// BigCockKnockout
export const FIRST_FIGHT = 'FirstFight' as const;
export const SECOND_FIGHT = 'SecondFight' as const;
export const FINAL_FIGHT = 'FinalFight' as const;
